import { createApp } from 'vue';
import App from './components/App.vue';
import store from './store';
import { registerDirectives } from './components/common/vueGlobals';
import { registerIcons } from './icons';
import './styles';
import './styles/app.scss';
import './styles/markdownHighlighting.scss';

// Extensions MUST be loaded synchronously before app mounts
// so that markdownConversionSvc.init() can use them
import './extensions';
import './services/optional';

const app = createApp(App);
app.use(store);
registerDirectives(app);
registerIcons(app);
app.mount('#app');
